module.exports = {
  src: __webpack_public_path__ + "assets/images/correct-green.466190d9eab7279a.svg",
  width: 14,
  height: 15,
  toString: function() { return __webpack_public_path__ + "assets/images/correct-green.466190d9eab7279a.svg"; }
};